/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import ScrollLock from 'components/ScrollLock'
import styles from './News.scss';
import iconArrow from 'assets/images/icons/arrow-right.svg';
import { monthToString, formatDate } from 'utils'
import { loadNews } from 'actions/building'
import { setPopUp } from 'actions/environment'
import { withTranslation } from 'react-i18next';

class News extends Component {

  handleMoreClick = (e) => {
    e.preventDefault()
    const { building, t } = this.props
    const { news } = building

    this.props.setPopUp(
      <div className={styles.NewsPopupWrap}>
        <div className={styles.PopupTitle}>
          <span>
            {t('components.building.main.news.titleBig', {
              title: building.data.title
            })}
          </span>
        </div>
        <ScrollLock>
          <div className={cn(styles.PopupNewsList, 'custom-scrollbar')}>
            {
              news.map(
                ({dateCreate, name}, i) => {
                  const message = []

                  name.replace(/((?:https?:\/\/|ftps?:\/\/|\bwww\.)(?:(?![.,?!;:()]*(?:\s|$))[^\s]){2,})|(\n+|(?:(?!(?:https?:\/\/|ftp:\/\/|\bwww\.)(?:(?![.,?!;:()]*(?:\s|$))[^\s]){2,}).)+)/gim, (m, link, text) => {
                    message.push(link ? <a target='_blank' href={(link[0]==="w" ? "//" : "") + link} key={message.length}>{link}</a> : text)
                  })

                  return (
                    <div className={styles.PopupNewsItem} key={`${i}-${dateCreate}-${name}`}>
                      <time className={styles.PopupNewsItemDate}>{formatDate(dateCreate)}</time>
                      <p className={styles.PopupNewsItemText}>
                        {message}
                      </p>
                    </div>
                  )
                }
              )
            }
          </div>
        </ScrollLock>
      </div>,
      {
        className: styles.NewsPopup,
        contentClassName: styles.NewsPopupContent,
        closeStyleName: 'Default',
        contentStyleName: 'Default',
        closeIcon: 'default',
        lockScroll: false,
      }
    )
  }

  UNSAFE_componentWillMount() {
    this.props.loadNews(this.props.params.id)
  }

  render() {
    const { className, building, client, t } = this.props;
    const { news } = building;

    const sortedNews = news && news.sort((a, b) => {
      if (a.dateCreate > b.dateCreate) return -1;
      if (a.dateCreate < b.dateCreate) return 1
      return 0;
    });

    return (
      news && news.length ?
      <div className={cn(styles.News, className)}>
        <h3 className={client ? styles.TitleClient : styles.Title}>
          {t('components.building.main.news.title')}
        </h3>
        <div className={styles.NewsList}>
          {
            sortedNews.slice(0, 3).map(
              ({dateCreate, name}, i) => (
                <div className={styles.NewsItem} key={`${dateCreate}-${name}-${i}`}>
                  <time className={styles.NewsItemDate}>{ formatDate(dateCreate) }</time>
                  <p className={styles.NewsItemText}>
                    { name.length > 100 ? `${name.slice(0,100)}…` : name}
                  </p>
                  {
                    name.length > 100 ?
                    <span onClick={this.handleMoreClick} className={styles.NewsItemLink}>
                      {t('components.building.main.news.readMore')}
                    </span> : null
                  }
                </div>
              )
            )
          }

          {(news.length > 3) ? (
            <span className={styles.AllNews} onClick={this.handleMoreClick}>
                {t('components.building.main.news.seeAll')} ({news.length}) <img src={iconArrow} alt=""/>
            </span>
          ) : ('')}

        </div>
      </div> : null
    );
  }
}

export default withTranslation()(connect(null, { loadNews, setPopUp })(News));



// WEBPACK FOOTER //
// ./src/components/Building/Main/News/News.js